import ActionFooter from './ActionFooter'

ActionFooter.install = (Vue, options) => {
  Vue.component(ActionFooter.name, ActionFooter)
}
export default ActionFooter


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/ActionFooter/index.js
// module id = null
// module chunks = 